import { useMemo } from 'react';

/**
 * Period-aware copy helper for Analytics hero text.
 * @param {{ year: number, month: number, monthLabel: string }} args 1-indexed month.
 * @returns {{ isCurrent: boolean, tense: 'present'|'past', periodPhrase: string }}
 */
export default function useAnalyticsTense({ year, month, monthLabel }) {
  return useMemo(() => {
    const now = new Date();
    const isCurrent =
      year === now.getFullYear() && month === now.getMonth() + 1;
    return {
      isCurrent,
      tense: isCurrent ? 'present' : 'past',
      periodPhrase: isCurrent ? 'this month' : `in ${monthLabel} ${year}`,
    };
  }, [year, month, monthLabel]);
}
